export enum BalooSyncResultType {
    NoChanges = 0,
    Created = 1,
    Updated = 2,
    MultipleEmailsInChainformation = 100,
    UnknownError = 200,
}
